import React from "react"
import SignupLayout from ".";
import BackgroundImg from "../../assets/images/background/integrations.png";
import { ConnectionSignup, SetupCoonectionImg } from "../../components/Icons/iconImages";
import { Button } from "antd";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Icons from '../../components/Icons';
import FirstIntegrations from "../Integrations/firstIntegration";
import { getSession } from "../../services/auth";
import { useAddGaAccountForNewUserMutation } from "../../services/authSlice";

const SetUpConnection = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const defaultValues = {
        excisitingTool: '',
    };

    const [addGaAccount] = useAddGaAccountForNewUserMutation();

    const {
        getValues,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues,
    });
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    const handleClickAddGaAccount = async () => {
        addGaAccount('')
            .unwrap()
            .then((res) => {

            })
            .catch((err) => {
            }
            )
    }

    const handleSignUp = async () => {
        handleClickAddGaAccount();
        try {
            const session: any = await getSession()
            const token = session.idToken.jwtToken;
            const user = state?.header?.Authorization?.split(' ')[1];
            if (token || user) {
                if (user) {
                    localStorage.setItem("oogw.ai_user", user)
                    navigate('/dashboard')
                } else {
                    localStorage.setItem("oogw.ai_user", token)
                    navigate('/dashboard')
                }
            } else {
                navigate('/login')
            }
        } catch (error) {
            setLoading(false)
            navigate('/login')
        }
    }


    return (
        <SignupLayout
            title={<p className="text-[#FFFFFF] font-bold text-6xl 2xl:text-7xl mt-3 ">Connect & Listen to the stories your data is telling you</p>}
            description={<p className="text-[#FFFFFF] text-xl mt-3">Finish setting up and let AI reveal
                {' '}  <span className="relative border border-[#FDB022] text-[#F79009] font-semibold px-1.5 py-0.5 bg-[#325142] inline-block">
                    <span className="absolute h-[5px] w-[5px] top-[-3px] left-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] top-[-3px] right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] left-[-3px] bg-[#FDB022]"></span>
                    hidden growth opportunities
                </span>{' '}
                across all your marketing channels.
            </p>}
            // background={BackgroundImg}
            icon={<ConnectionSignup className="h-[80px] w-[80px] " />}
            percent={100}
            currentStep={7}
        >
            <div className=" text-center mt-8">
                <div className="border border-gray-300 w-[56px] h-[56px] rounded-xl flex items-center justify-center m-auto shadow-sm">
                    <SetupCoonectionImg className="mx-auto text-center block" />
                </div>
                <p className="text-[#181D27] font-semibold text-3xl mt-4">Set up Integrations</p>
                <p className="text-[#535862] text-md mt-2">Connect to your data sources</p>
            </div>
            <div className="space-y-5 md:space-y-5 w-[70%] mx-auto mt-6">

                <FirstIntegrations signup={true} />

                {error && (
                    <div className="flex items-center justify-between w-full border-t border-gray-200 dark:border-gray-600 pt-4">
                        <p className='text-red-500 text-sm'>{error}</p>
                        <Icons icon={"heroicons-outline:x-circle"} className="max-h-5 max-w-5 h-5 w-5 text-red-500 cursor-pointer" onClick={() => setError(null)} />
                    </div>
                )}

                <div className="flex items-center gap-3">
                    {state?.header?.Authorization && <p className="text-[#609F81] cursor-pointer font-semibold" onClick={() => navigate('/setup-workspace', {
                        state: {
                            ...state,
                        }
                    })}>Back</p>}

                    <Button
                        type='primary'
                        className="w-full "
                        disabled={loading}
                        loading={loading}
                        onClick={handleSignUp}
                        htmlType="submit"

                    >
                        Finish Setup
                    </Button>
                </div>

            </div>
        </SignupLayout>
    )
};

export default SetUpConnection;
